import { createAsyncThunk } from '@reduxjs/toolkit';
import { CHANGEPASSWORD_API_URL } from '@custom/constant';

const changePasswordApi = createAsyncThunk('changePassword', async (values: any) => {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');

    try {
        let url = `${CHANGEPASSWORD_API_URL}`;
        let response = await fetch(url, {
            method: 'PUT',
            headers: {
                Authorization: 'Bearer ' + token,
                'content-Type': 'application/json'
            },
            body: JSON.stringify(values)
        })
        return await response.json()
    } catch (error) {
        return error;
    }
});

export default changePasswordApi;
